var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("rule-item", {
        attrs: {
          isDelete: false,
          ruleForm: _vm.ruleForm,
          propertyDatas: _vm.propertyDatas,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }